export enum AccountStatusEnum {
  Pending = 1,
  Active = 2,
  Inactive = 3,
  Struck = 4,
  Suspended = 5
}
